import { SystemIcon } from '@helpers/icons';
import * as React from 'react';
import { LinkButton } from '../Buttons/Button/Button';
import S from './CalculatorResponse.styles';
const CalculatorResponse = (props) => {
    return (React.createElement(S.Container, { "data-type": props.type },
        props.properties.map((property, i) => (React.createElement(S.Property, { key: `calculator-response-${i}` },
            React.createElement(S.Label, null, property.label),
            React.createElement(S.Value, null,
                property.value,
                property.tooltip && (React.createElement(S.Info, null,
                    React.createElement(S.InfoButton, { "aria-label": props.translations?.['global.tooltip.label'], "aria-describedby": `calculator-response-${i}-tooltip-label`, onClick: (e) => e.preventDefault() }, "?"),
                    React.createElement(S.Tooltip, { id: `calculator-response-${i}-tooltip-label`, role: "tooltip" }, property.tooltip))))))),
        props.linkButton && (React.createElement(LinkButton, { buttonType: "tertiary", icon: SystemIcon.None, href: props.linkButton.url, target: props.linkButton.target }, props.linkButton.text))));
};
export default CalculatorResponse;
